export default "__VITE_ASSET__DYx7Ax7Q__"